const getters = {
  token: state => state.user.token,
  routeFlag: state => state.user.routeFlag,
  userInfo: state => state.user.userInfo,
  // 萤石云相关
  ezvizInfo: state => state.ezviz.ezvizInfo,
  ezvizToken: state => {
    const info = state.ezviz.ezvizInfo;
    if (!info || !info.timestamp || Date.now() > info.timestamp) {
      return null;
    }
    return info.token;
  }
};

export default getters;
